export {default as DceFragmentsPlugin} from "./fragments/dceplugin/DceFragmentsPlugin"
export {default as Fragment} from "./fragments/Fragment"
export {default as LazyFragment} from "./fragments/LazyFragment"
export {default as ModalFragment} from "./fragments/ModalFragment"
export {default as DceFragmentsContext} from "./fragments/dceplugin/FragmentsContext"
export {default as FragmentsContext} from "./fragments/dceplugin/FragmentsContext";

import {DceAjax} from "dce-ajax";
import DceWireXStyleProcessor from "./fragments/ajax/DceWireXStyleProcessor";

DceAjax.getInstance().registerResponseProcessor(new DceWireXStyleProcessor());
